import { render, staticRenderFns } from "./CalculationTabs.vue?vue&type=template&id=4557af42&"
import script from "./CalculationTabs.vue?vue&type=script&lang=js&"
export * from "./CalculationTabs.vue?vue&type=script&lang=js&"
import style0 from "./CalculationTabs.vue?vue&type=style&index=0&id=4557af42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports